<template>
    <div class="d-flex flex-column">
        <!-- DatosPersonales -->
        <v-card class="rounded-0" v-if="Object.keys(datosPersonales).length >= 1" flat>
            <v-card-title class="font-weight-bold primary--text text-h5 mx-5">
                <v-icon class="mr-3" color="primary" size="34">
                    mdi-account-outline
                </v-icon>
                Datos Personales
            </v-card-title>
            <v-row class="mx-5">
                <v-col cols="12" md="3" class="d-flex flex-column justify-start align-center">
                    <div class="font-weight-bold primary--text text--lighten-1 text-body-1 mb-2">
                        FOTO DE LEGAJO
                    </div>
                    <v-avatar tile size="180" class="elevation-6">
                        <img v-if="datosPersonales.fotocarnet != ''"
                            :src="`data:image/png;base64,${datosPersonales.fotocarnet}`" alt="foto legajo">
                        <img v-else src="@/assets/blank-user-profile.png" alt="alt">
                    </v-avatar>
                </v-col>
                <v-col cols="12" md="9">
                    <SimpleTable :desserts="itemsDatosPersonales"></SimpleTable>
                </v-col>
            </v-row>
        </v-card>

        <!-- si hay datos de conyuge -->
        <v-card class="rounded-0" v-if="Object.keys(datosFamiliares).length >= 1" flat>
            <v-card-title class="font-weight-bold primary--text text-h5 mx-5">
                <v-icon class="mr-2" color="primary" size="34">
                    mdi-account-multiple-outline
                </v-icon>
                Datos conyuge/conviviente
            </v-card-title>
            <v-row class="mx-5">
                <v-col cols="12" md="12">
                    <SimpleTable :desserts="itemsDatosFamiliares"></SimpleTable>
                </v-col>
            </v-row>
        </v-card>

        <!-- Si hay datos de hijos 
        v-if="datosHijos.length >= 1" 
        -->
        <v-card class="rounded-0" flat v-if="datosHijos.length >= 1">
            <v-card-title class="font-weight-bold primary--text text-h5 mx-5">
                <v-img :src="getImage()" max-width="36px" class="mr-2" />
                Datos Hijos
            </v-card-title>
            <v-row class="mx-5">
                <v-col cols="12" md="12" v-for="(item, index) in itemsDatosHijos" :key="index">
                    <SimpleTable :desserts="item"></SimpleTable>
                </v-col>
            </v-row>
        </v-card>

        <!-- DatosContacto -->
        <v-card class="rounded-0" v-if="Object.keys(datosContacto).length >= 1" flat>
            <v-card-title class="font-weight-bold primary--text text-h5 mx-5">
                <v-icon color="primary" class="mr-3" size="34">mdi-card-account-phone-outline>
                    mdi-comment-account-outline
                </v-icon>
                Mis medios de contacto
            </v-card-title>
            <v-row class="mx-5">
                <v-col cols="12" md="12">
                    <SimpleTable :desserts="itemsDatosContacto">
                    </SimpleTable>
                </v-col>
            </v-row>
        </v-card>
        <!-- DatosProfesionales-->
        <v-card class="rounded-0" v-if="Object.keys(datosProfesionales).length >= 1" flat>
            <v-card-title class="font-weight-bold primary--text text-h5 mx-5">
                <v-icon class="mr-3" color="primary" size="34">
                    mdi-account-school-outline
                </v-icon>
                Datos Profesionales
            </v-card-title>
            <v-row class="mx-5">
                <v-col cols="12" md="12">
                    <SimpleTable :desserts="itemsDatosProfesionales"></SimpleTable>
                </v-col>
            </v-row>
        </v-card>
        <!-- DatosNivel-->
        <v-card class="rounded-0" v-if="Object.keys(datosNivel).length >= 1" flat>
            <v-card-title class="font-weight-bold primary--text text-h5 mx-5">
                <v-icon class="mr-3" color="primary" size="34">
                    mdi-account-star-outline
                </v-icon>
                Opción de nivel
            </v-card-title>
            <v-row class="mx-5">
                <v-col>
                    <SimpleTable :desserts="itemsDatosNivel"></SimpleTable>
                </v-col>
            </v-row>
        </v-card>
        <v-divider class="my-6 mx-5"></v-divider>
        <ValidationObserver ref="obs" v-slot="{ invalid }">
            <v-form name="form-afiliacion" @submit.prevent="submit">
                <v-card class="rounded-0" flat>
                    <v-row class="mx-5 mb-2">
                        <v-col cols="12" md="12">
                            <ValidationProvider :rules="{ required: { allowFalse: false } }" v-slot="v">
                                <v-checkbox dense v-model="confirmar" :error-messages="v.errors[0]">
                                    <template v-slot:label>
                                        <div
                                            :class="(confirmar) ? `font-weight-regular primary--text` : `font-weight-regular dark--text`">
                                            Confirmo que todos mis datos son correctos.
                                        </div>
                                    </template>
                                </v-checkbox>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-divider class="my-6 mx-5"></v-divider>
                    </v-row>
                </v-card>
                <div class=" form-footer d-flex justify-space-between" @click="forzarValidacion">
                    <v-btn color="secondary" outlined elevation="0" @click="volver" class="pa-5">
                        <v-icon class="mr-2">mdi-chevron-left</v-icon>atras
                    </v-btn>
                    <v-btn color="primary" elevation="0" :disabled="invalid" :loading="loading" type="submit"
                        class="pa-5">
                        <v-icon class="mr-2">mdi-send-outline</v-icon>finalizar trámite
                    </v-btn>
                </div>
            </v-form>
        </ValidationObserver>
    </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'
import SimpleTable from '@/components/grids/SimpleTable.vue'
import imgHijo from '@/assets/afiliacion/img-datos-hijos.png'
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
    name: 'form-pre-vista',
    components: {
        ValidationObserver,
        ValidationProvider,
        SimpleTable,
    },
    data() {
        return {
            componentKey: 0,
        }
    },

    mounted() {
    },
    methods: {
        ...mapActions('common', ['getCodigoPais', 'getNacionalidades', 'getTipoNacionalidad', 'getLocalidades', 'getTipoContactoFiltro']),
        ...mapActions('preafiliacion', ['crearFormData']),

        getImage() {
            return imgHijo
        },
        forzarValidacion() {
            this.$refs.obs.validate().then(result => {
                if (!result) {
                    const firstErrorElement = this.$el.querySelector('.v-messages__message');
                    if (firstErrorElement) firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        },

        submit() {
            this.$refs.obs.validate().then(result => {
                if (result) {
                    this.crearFormData().finally(() => {
                        this.$emit('siguiente')
                        //this.router.push('/Login').catch(() => {})
                    })
                } else {
                    console.log('Formulario inválido, no se puede enviar la petición');
                    this.showSnack({
                        type: '400',
                        message: 'Formulario invalido, revise los campos.'
                    })
                }
            });
        },

        volver() {
            this.opcionNivelVista = []
            this.$emit('atras')
        },
        formatDate(date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        }

    },
    computed: {
        ...mapGetters('common', ['nacionalidad']),
        ...mapGetters('preafiliacion', ['datosPersonales', 'itemsDatosPersonales', 'itemsDatosContacto', 'itemsDatosProfesionales', 'itemsDatosHijos',
            'itemsDatosFamiliares', 'itemsDatosNivel', 'archivosPersonales', 'datosFamiliares', 'datosContacto', 'datosProfesionales',
            'datosNivel', 'datosHijos']),
    },

}
</script>